import DOMPurify from 'dompurify';

// Quill's links open in a new tab, and DOMPurify drops `target` unless asked to keep it. A link
// that does must not hand the new page `window.opener`, whatever rel it was saved with.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * HTML that someone other than the viewer wrote, made safe to render: formatting, links and
 * images stay; scripts, event handlers, `javascript:` URLs and embeds go. Every
 * `dangerouslySetInnerHTML` goes through this, and lint enforces it.
 */
export const sanitizeHtml = (html: string | undefined): string =>
  DOMPurify.sanitize(html ?? '', { ADD_ATTR: ['target'] });
